module.exports = "https://cdn.dove.it/_next/static/public/assets/press/logo-larepubblica.4ef906fc5c542161503991b319163d2b.png";